export const REQUEST_BULK_USER_UPLOAD = 'BULK_UPLOAD/REQUEST_BULK_USER_UPLOAD';
export const REQUEST_BULK_USER_UPLOAD_SUCCESS = 'BULK_UPLOAD/REQUEST_BULK_USER_UPLOAD_SUCCESS';
export const SET_BULK_USER_UPLOAD_STAGE = 'BULK_UPLOAD/SET_BULK_USER_UPLOAD_STAGE';
export const RESET_BULK_USER_UPLOAD_STATE = 'BULK_UPLOAD/RESET_BULK_USER_UPLOAD_STATE';

export function bulkUserUpload(file) {
  return {
    type: REQUEST_BULK_USER_UPLOAD,
    file: file,
  };
}

export function bulkUserUploadSuccess(response) {
  return {
    type: REQUEST_BULK_USER_UPLOAD_SUCCESS,
    loading: false,
    userId: response.userId,
  };
}

export function setBulkUserUploadStage(payload) {
  return {
    type: SET_BULK_USER_UPLOAD_STAGE,
    stage: payload.stage,
    importMessages: payload.importMessages,
  };
}

export function resetBulkUserUploadState() {
  return {
    type: RESET_BULK_USER_UPLOAD_STATE,
  };
}